// Seller Center access as seen from the Backoffice (spec mdf-project
// docs/specs/2026-10-16-seller-roles-and-design-editor.md §6 step 5, issue
// asrth/mdf-bo-api#980). Pure — jest pins it.
//
// Since bo-api #986 the seller permissions live in bo_seller_permission and
// are managed in the Seller Center; the login body carries them as
// `seller_access` = {admin, super_admin, perms, can_use_app}. The legacy
// `roles.seller` key is read only as a fallback for an API without the field.

export const SELLER_PERMS = ["catalog", "orders", "design", "payment_report"];

// normalizeSellerAccess(raw) → {admin, super_admin, perms} or null when the
// login body has no `seller_access` (older API).
export function normalizeSellerAccess(raw) {
    if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;
    const list = Array.isArray(raw.perms) ? raw.perms.map(String) : [];
    return {
        admin: raw.admin === true,
        super_admin: raw.super_admin === true,
        perms: SELLER_PERMS.filter((p) => list.includes(p))
    };
}

// isSellerUser(user) — the Vuex user (group, roles, seller_access).
//   with seller_access: Seller Admin || any grant || group 99
//   without:            roles.seller > 0 || group 1 / 99 (the old mw.IsSeller)
export function isSellerUser(user) {
    const u = user || {};
    const group = Number(u.group);
    const a = u.seller_access;
    if (a && typeof a === "object") {
        return a.admin === true || a.super_admin === true || group === 99 || (Array.isArray(a.perms) && a.perms.length > 0);
    }
    if (group === 1 || group === 99) return true;
    try {
        return Number(u.roles && u.roles.seller) > 0;
    } catch (e) {
        return false;
    }
}
